// extracted by mini-css-extract-plugin
export default {"socials":"SocialContacts_socials__cS79m"};